import React from 'react';
export const Loading = () => {
  return /*#__PURE__*/React.createElement("div", null, "Loading...");
};